// extracted by css-extract-rspack-plugin
export default {"dialog":"PrefixesDialog-module__dialog__HllOX","dialogBody":"PrefixesDialog-module__dialogBody__Rv47U","helpIcon":"PrefixesDialog-module__helpIcon__bde8Q"};